import { createReducer, on, Action } from '@ngrx/store';
import { LoadState } from '@nx-ng/types';
import { AddressResponse, AddressSearchDrillDownResponse, AddressSearchResponse } from '../../client/src';
import { AddressesStoreActions } from '../../actions';

export interface IAddressesState {
  search: {
    response?: AddressSearchResponse | AddressSearchDrillDownResponse;
    loaded: LoadState;
    error?: unknown | string;
  };
  address: {
    addressResponse?: AddressResponse;
    loaded: LoadState;
    error?: unknown | string;
  };
}

export const initialState: IAddressesState = {
  search: {
    response: undefined,
    loaded: LoadState.NOT_LOADED,
    error: undefined,
  },
  address: {
    addressResponse: undefined,
    loaded: LoadState.NOT_LOADED,
    error: undefined,
  },
};

const addressReducer = createReducer(
  initialState,
  on(AddressesStoreActions.addressAPI_search, (state) => ({
    ...state,
    search: {
      ...state.search,
      loaded: LoadState.LOADING,
      error: undefined,
    },
  })),
  on(
    AddressesStoreActions.addressAPI_searchSuccess,
    (state, { searchResponse }) => ({
      ...state,
      search: {
        ...state.search,
        loaded: LoadState.LOADED,
        response: searchResponse,
      },
    })
  ),
  on(AddressesStoreActions.addressAPI_searchFailure, (state, { error }) => ({
    ...state,
    search: {
      ...state.search,
      loaded: LoadState.FAILED,
      error,
    },
  })),
  on(AddressesStoreActions.addressAPI_drillDown, (state) => ({
    ...state,
    search: {
      ...state.search,
      loaded: LoadState.LOADING,
      error: undefined,
    },
  })),
  on(
    AddressesStoreActions.addressAPI_drillDownSuccess,
    (state, { searchResponse }) => ({
      ...state,
      search: {
        ...state.search,
        loaded: LoadState.LOADED,
        response: searchResponse,
      },
    })
  ),
  on(AddressesStoreActions.addressAPI_drillDownFailure, (state, { error }) => ({
    ...state,
    search: {
      ...state.search,
      loaded: LoadState.FAILED,
      error,
    },
  })),
  on(AddressesStoreActions.addressAPI_retrieve, (state) => ({
    ...state,
    address: {
      ...state.address,
      loaded: LoadState.LOADING,
      error: undefined,
    },
  })),
  on(
    AddressesStoreActions.addressAPI_retrieveSuccess,
    (state, { address }) => ({
      ...state,
      address: {
        // We have an address - clear all except search session key
        ...state.address,
        loaded: LoadState.LOADED,
        error: undefined,
        response: {
          session: state.search.response?.session
        },
      },
    })
  ),
  on(AddressesStoreActions.addressAPI_retrieveFailure, (state, { error }) => ({
    ...state,
    address: {
      ...state.address,
      loaded: LoadState.FAILED,
      error,
    },
  }))
);

export function reducer(state: IAddressesState | undefined, action: Action) {
  return addressReducer(state, action);
}
